export default {
  title: {
    add: 'Script hinzufügen',
    update: 'Script aktualisieren',
  },
  form: {
    strategy: {
      label: 'Strategie',
      placeholder: 'Strategie auswählen',
    },
    source: {
      label: 'Quelle (src)',
      placeholder: 'Quelle eingeben',
    },
    async: {
      label: 'Asynchron',
      placeholder: 'Async auswählen',
    },
    content: {
      label: 'Inhalt',
      placeholder: 'Inhalt eingeben',
    },
  },
  alert: {
    use_case: 'Anwendungsfall',
  },
  buttons: {
    save: 'Speichern',
  },
};
